import './App.scss';

import moment from 'moment';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  withRouter
} from 'react-router-dom';
import React, { Component, useState } from "react";
import socketIOClient from "socket.io-client";

import ImageGallery from './ImageGallery';
import Infobox from './Infobox';
import Toolbox from './Toolbox';
import Timer from './Timer';
import axios from "axios";


let {REACT_APP_STICKITY_URL, REACT_APP_GSCOLSERVER_URL} = process.env;
var socket = socketIOClient(REACT_APP_GSCOLSERVER_URL);


class App extends React.Component {

  constructor(props) {
    super(props);

    const { id } = props.id ? props : props.match.params;
    const { game } = props.game ? props : props.match.params;
    const { instance } = props.instance ? props : props.match.params;

    this.state = {
      gs: [],
      gsId: id,
      game: game,
      instance: instance,
      countdown: null,
      startTime: null,
    }
  }

  componentDidMount() {
    socket.emit('create',this.state.instance + '-' + this.state.game)
    if ( this.state.gsId ) {
      REACT_APP_STICKITY_URL += this.state.gsId;
    }

    axios.get(REACT_APP_STICKITY_URL)
        .then( (response) => {

          let { countdown } = response.data;

          document.title += ' - ' + response.data.group + ' - ' + response.data.customer_name;

          this.setState({
            gs: response.data,
            countdown: countdown
          });
        })
        .catch(error => {
          console.log("ERROR::", error.message)
        });


  }

  render() {

    const info = this.state.gs.info;
    let timeTillDate = 0;

    const now = moment();

    let imageGallery = <Infobox />

    if (this.state.gs.id) {
      timeTillDate = this.state.gs.countdown > 0 ? now.add(this.state.gs.countdown, 'm') : 0;
      imageGallery = <ImageGallery
          gsId={this.state.gs.id}
          instance={this.state.instance}
          game={this.state.game}
          heading={this.state.gs.header}
          options={this.state.gs.options}
          header1={this.state.gs.choice_area_header_1}
          header2={this.state.gs.choice_area_header_2}
          messageSuccess={this.state.gs.message_check_success}
          messageFailure={this.state.gs.message_check_failure}
          onchange={(e, selectedImages) => this.saveSelectedImages(e, selectedImages)}/>
    }

    return (
        <div className="App container-fluid">

          <div className="Header row rounded-top align-content-center text-center">&nbsp;</div>
          <div className="Main row">
            <div className="Tools col col-lg-1">
              <Infobox info={info} />
              <Toolbox onClickSubmit={(e) => this.handleClickSubmit()} />
              {
                timeTillDate != 0
                    ?
                    <Timer
                        gameId={this.state.gsId}
                        game={this.state.game}
                        instance={this.state.instance}
                        countdown={this.state.countdown}
                        timeTillDate={timeTillDate}
                        timeFormat="MM DD YYYY, h:mm a" />
                    :
                    null
              }

            </div>
            <div className="Gallery col col-lg-11">
              {imageGallery}
            </div>
          </div>

        </div>
    );
  }
}

export default withRouter(App);
export {socket};
